/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_VirtualInputs */

const en_ui_sub_sport_virtual = /** @type {(inputs: Ui_Sub_Sport_VirtualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual`)
};

const de_ui_sub_sport_virtual = /** @type {(inputs: Ui_Sub_Sport_VirtualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtuell`)
};

/**
* | output |
* | --- |
* | "Virtual" |
*
* @param {Ui_Sub_Sport_VirtualInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_virtual = /** @type {((inputs?: Ui_Sub_Sport_VirtualInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_VirtualInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_virtual(inputs)
	return de_ui_sub_sport_virtual(inputs)
});